import { render, staticRenderFns } from "./PlayerResearchComplete.vue?vue&type=template&id=a390ce0e&scoped=true&"
import script from "./PlayerResearchComplete.vue?vue&type=script&lang=js&"
export * from "./PlayerResearchComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a390ce0e",
  null
  
)

export default component.exports